import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'sonner';
import App from './App';
import './index.css';
import { getMode } from './lib/theme'; // side-effect: paints the persisted mode before render

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
      <Toaster theme={getMode()} position="bottom-right" />
    </BrowserRouter>
  </React.StrictMode>
);
